module.exports = __webpack_public_path__ + "img/1.b7e71cad.jpg";